import { Clock } from "lucide-react";

export const ComingSoon = ({ title, description = "We're polishing this up. It'll be available for your account soon." }) => (
  <div className="space-y-6" data-testid="panel-coming-soon">
    <div className="rounded-3xl border border-purple-100 bg-white p-10 sm:p-14 text-center">
      <div className="mx-auto w-12 h-12 rounded-2xl bg-purple-50 text-purple-700 flex items-center justify-center mb-4">
        <Clock className="w-5 h-5" />
      </div>
      <div className="font-heading text-lg font-extrabold text-slate-900">{title} · Coming soon</div>
      <p className="text-sm text-slate-500 mt-2 max-w-sm mx-auto">{description}</p>
    </div>
  </div>
);
